// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_CATEGORY_PLANS = "GET_CATEGORY_PLANS";
export const CREATE_CATEGORY_PLANS = "CREATE_CATEGORY_PLANS";
export const UPDATE_CATEGORY_PLANS = "UPDATE_CATEGORY_PLANS";
export const DELETE_CATEGORY_PLANS = "DELETE_CATEGORY_PLANS";

export const RESET_CATEGORY_PLANS = "RESET_CATEGORY_PLANS";